module.exports = __webpack_public_path__ + "static/media/checked@2x.471c53f6.png";